import { requestOperation, unwrapData } from '../../../api/client';

export const companyResearchApi = {
  list: () => requestOperation('GET /api/v1/company-research'),
  get: async (id: string, signal?: AbortSignal) => unwrapData(await requestOperation<{ data: unknown }>('GET /api/v1/company-research/{id}', { path: { id }, config: { signal } })),
  deepDive: (input: unknown) => requestOperation('POST /api/v1/company-research/deep-dive', { body: { input }, config: { timeout: 300000 } }),
  retry: (id: string) => requestOperation('POST /api/v1/company-research/{id}/retry', { path: { id }, config: { timeout: 300000 } }),
  remove: (id: string) => requestOperation('DELETE /api/v1/company-research/{id}', { path: { id } }),
};
